import {ActionIcon, Button, Flex, Grid, GridProps, Group} from "@mantine/core";
import {Entity, MessageEntity} from "@ots-frontend/ots-data";
import { CommentModal } from "../../../comment/CommentModal/CommentModal";
import { useEntityCommentModal } from "../../../comment/EntityCommentModal/useEntityCommentModal";
import { EntityCommentList } from "../../../comment/EntityCommentList/EntityCommentList";
import {IconMessagePlus} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {useCallback} from "react";
import {useMessageMutation} from "../../../../hooks/useMessageMutation";

export type EntityNotesViewProps = Omit<GridProps, 'children'> & {
  entity: Entity
}

export const EntityNotesView = (props: EntityNotesViewProps) => {
  const {
    entity,
    ...rest
  } = props

  const { t } = useTranslation(["translation", "common"]);

  const {
    opened,
    handlers,
    onSubmit: onCommentSubmit,
    isCreating: isCommentCreating
  } = useEntityCommentModal({
    entity: entity
  });

  const {
    deleteMessage,
  } = useMessageMutation()

  const onDelete = useCallback((message: MessageEntity) => {
    deleteMessage(message.id, undefined)
  }, [deleteMessage])

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <Flex justify="flex-end">
          <Button onClick={handlers.open} leftIcon={<IconMessagePlus size={16}/>} ta="end">
            {t("common.action.add.note", "Add Note")}
          </Button>
        </Flex>
      </Grid.Col>
      <Grid.Col span={12}>
        <EntityCommentList
          objectId={entity.id}
          onAddComment={handlers.open}
          addCommentLabel={t<string>("common.action.add.note", "Add Note")}
          emptyMessage={t<string>("common.view.entitynotes.empty", "No Notes")}
          onEdit={undefined}
          onDelete={onDelete}
        />
      </Grid.Col>

      <CommentModal
        opened={opened}
        onClose={handlers.close}
        onSubmit={onCommentSubmit}
        loading={isCommentCreating}/>

    </Grid>
  )
}
